import Vue from 'vue'
import VueRouter from 'vue-router';
import staticRoutes from './staticRoutes';
import whiteList from "./whiteList";
Vue.use(VueRouter);


const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err)
}
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};


const router = new VueRouter({
  mode: 'hash',
  routes: staticRoutes,
});

router.beforeEach((to, from, next) => {
  // 获取localstorage里的token
  let token = localStorage.getItem('token');
  // 如果为白名单，直接访问
  if (whiteList.includes(to.path)) {
    return next();
  }
  // 如果存在token，则初始化数据，
  if (token) {
    return next();
  } else {
    // 如果用户无登录的token
    let link = "http://zhlgd.whut.edu.cn/tpass/login?service=" + encodeURIComponent(window.location.origin);
    window.open(link,"_self")
    // if(to.path === '/login') return next();
    // return next({ path: '/login', replace: true });
  }
})

export default router;

